import React from "react"
import { withPrefix } from "gatsby-link"

import Button from "../../../shared/components/atoms/button/button"

import "./environmental-card.scss"

const EnvironmentalCard = () => {
  var packageDeliveryLink = withPrefix("/entrega-empaques")

  const isPeru = process.env.LOCALE === "es-PE"
  const isColombia = process.env.LOCALE === "es-CO"
  const isDo = process.env.LOCALE === "es-DO"
  const isAr = process.env.LOCALE === "es-AR"
  const isPuertoRico = process.env.LOCALE === "es-PR"
  const isParaguay = process.env.LOCALE === "es-PY"
  const isChile = process.env.LOCALE === "es-CL"
  const isEcuador = process.env.LOCALE === "es-EC"

  return (
    <>
      <div className={"f-environmental-card"}>
        <span className="f-card-title">
          {isColombia ? "¡Más Loving para el planeta!" : "Sostenibilidad"}
        </span>
        <span
          className={`f-earth-img ${
            isColombia ? "f-earth-img--package-delivery" : ""
          }`}
        />
        <p className="f-description-card">
          {isPeru || isDo || isAr || isPuertoRico || isParaguay || isChile ? (
            `Para Nosotras es muy importante cuidar el planeta y ${
              isAr || isParaguay ? "vos podés" : "tú puedes"
            } ayudarnos. Próximamente te contaremos cómo.`
          ) : isEcuador ? (
            <>
              Es importante que te quedes en casa y te sigas cuidando, por eso
              hemos habilitado temporalmente nuestro canal de Whatsapp para que
              puedas enviar las imágenes de tus empaques y así seguir redimiendo
              tus premios. Para Nosotras es muy importante cuidar el planeta,
              así que síguelos guardando porque muy pronto tendremos puntos
              autorizados para que los entregues y sigas ayudando así a la
              economía circular.
            </>
          ) : isColombia ? (
            <>
              Únete y dale una nueva vida a tus empaques Nosotras: reúnelos y
              llévalos a Servientrega para que podamos recogerlos y
              transformarlos en nuevos objetos como parques infantiles,
              mangueras, libros y más. Así entre todas ayudamos a hacer un
              planeta más sostenible y continuamos haciendo parte de la economía
              circular. Haz clic y conoce cómo empezar a ayudar.
            </>
          ) : (
            "Para Nosotras es muy importante cuidar el planeta y tú puedes ayudarnos, entregando los empaques de tus productos Nosotras en nuestros puntos autorizados."
          )}
        </p>
        <div className="f-button-container">
          {isColombia && (
            <Button
              className="primary-pink"
              title="Entérate cómo"
              onClick={e => {
                e.preventDefault()
                window.location = packageDeliveryLink
              }}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default EnvironmentalCard
